var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "purchase_part my-2" },
    [
      _c("cabinet-fl44-card-header", { attrs: { purchase: _vm.contract } }),
      _c("cabinet-fl44-card-subheader", { attrs: { purchase: _vm.contract } }),
      _c("cabinet-fl44-card-body", {
        scopedSlots: _vm._u([
          {
            key: "col1",
            fn: function () {
              return [
                _vm.contract.purchase_info.planned_end_date
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Планируемая дата исполнения" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateFormat(
                                _vm.contract.purchase_info.planned_end_date
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.isContractConcluded
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Контракт заключен" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateFormat(
                                _vm.contract.purchase_info.contract_date
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.purchase_info.contract_price
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Цена контракта" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$formatPrice(
                                _vm.contract.purchase_info.contract_price
                              )
                            ) +
                            " руб. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.purchase_info
                  .contract_price_with_supplementary_agreement
                  ? _c(
                      "cabinet-notice-card-row-single",
                      { attrs: { label: "Цена контракта с учётом ДС" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$formatPrice(
                                _vm.contract.purchase_info
                                  .contract_price_with_supplementary_agreement
                              )
                            ) +
                            " руб. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.flags.is_customer
                  ? _c("purchase-comment-edit-block", {
                      attrs: { purchase: _vm.contract },
                      on: { refresh: _vm.refresh },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "col2",
            fn: function () {
              return [
                _vm.contract.purchase_info.purchase_name
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      { attrs: { label: "Предмет закупки" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.contract.purchase_info.purchase_name) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.contract.flags.is_supplier
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      { attrs: { label: "Заказчик" } },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "system_link-style",
                            attrs: {
                              to: {
                                name: "OrganizationShow",
                                params: { id: _vm.contract.customer.id },
                              },
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.contract.customer.name) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.contract.flags.is_customer
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      { attrs: { label: "Поставщик" } },
                      [
                        _vm.contract.supplier.type === "private"
                          ? [
                              _vm._v(
                                " " + _vm._s(_vm.contract.supplier.name) + " "
                              ),
                            ]
                          : _c(
                              "router-link",
                              {
                                staticClass: "system_link-style",
                                attrs: {
                                  to: {
                                    name: "OrganizationShow",
                                    params: { id: _vm.contract.supplier.id },
                                  },
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.contract.supplier.name) + " "
                                ),
                              ]
                            ),
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "cabinet-notice-card-row-single",
                  { attrs: { label: "Количество позиций" } },
                  [
                    _vm._v(
                      _vm._s(_vm.contract.purchase_info.deliverables_count) +
                        " "
                    ),
                  ]
                ),
                _vm.contract.purchase_info.delivery_addresses &&
                _vm.contract.purchase_info.delivery_addresses.length
                  ? _c(
                      "cabinet-notice-card-row-dual",
                      {
                        attrs: {
                          label:
                            "Адреса для доставки товаров/выполнения работ/оказания услуг",
                        },
                      },
                      _vm._l(
                        _vm.contract.purchase_info.delivery_addresses,
                        function (address, index) {
                          return _c(
                            "p",
                            {
                              key: `${index}_${address.address}`,
                              staticClass: "fs-12 m-0 grey-color fw-600",
                            },
                            [_vm._v("— " + _vm._s(address.address))]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "col3",
            fn: function () {
              return [
                _c(
                  "cabinet-fl44-card-info-link",
                  {
                    attrs: {
                      to: {
                        name: "purchases.grouped.item.view",
                        params: { group: "fl44", id: _vm.contract.id },
                      },
                      icon: "search",
                    },
                  },
                  [_vm._v("Информация о закупке")]
                ),
                _c(
                  "cabinet-fl44-card-info-link",
                  {
                    attrs: {
                      to: {
                        name: "purchases.grouped.item.view",
                        params: { group: "fl44", id: _vm.contract.id },
                        hash: "#atmo-supplier-info",
                      },
                      icon: "small_helmet",
                    },
                  },
                  [_vm._v("Итоговый протокол ")]
                ),
                _c(
                  "cabinet-fl44-card-info-link",
                  {
                    attrs: {
                      to: {
                        name: "purchases.grouped.item.view",
                        params: { group: "fl44", id: _vm.contract.id },
                        hash: "#atmo-contract",
                      },
                      icon: "grey_contract",
                    },
                  },
                  [_vm._v("Контракт")]
                ),
                _c(
                  "cabinet-fl44-card-info-link",
                  {
                    attrs: {
                      to: {
                        name: "purchases.grouped.item.view",
                        params: { group: "fl44", id: _vm.contract.id },
                        hash: "#atmo-contract-fulfillment",
                      },
                      icon: "grey_file_small",
                    },
                  },
                  [_vm._v("Исполнение контракта")]
                ),
                _c("cabinet-fl44-notice-card-rate-button", {
                  attrs: { contract: _vm.contract },
                  on: { refresh: _vm.refresh },
                }),
                _c("cabinet-fl44-notice-card-create-external-button", {
                  attrs: { purchase: _vm.contract },
                }),
                _vm.contract.actions.allow_second_offer_contract
                  ? _c(
                      "b-button",
                      {
                        staticClass:
                          "btn btn-card-action btn-card-action-danger my-1",
                        attrs: {
                          to: {
                            name: "purchases.grouped.item.view",
                            params: { group: "fl44", id: _vm.contract.id },
                            hash: "#second-offer-contract",
                          },
                          exact: "",
                          target: "_blank",
                        },
                      },
                      [_vm._v(" Отправить контракт второму месту ")]
                    )
                  : _vm._e(),
                _vm.contract.actions.customer_need_sign_second_offer_contract
                  ? _c(
                      "b-button",
                      {
                        staticClass:
                          "btn btn-card-action btn-card-action-danger my-1",
                        attrs: {
                          exact: "",
                          target: "_blank",
                          to: {
                            name: "purchases.grouped.item.view",
                            params: { group: "fl44", id: _vm.contract.id },
                            hash: "#atmo-contract",
                          },
                        },
                      },
                      [_vm._v(" Подписать контракт ")]
                    )
                  : _vm._e(),
                _vm.contract.actions.customer_need_answer_dispute
                  ? _c(
                      "b-button",
                      {
                        staticClass:
                          "btn btn-card-action btn-card-action-danger my-1",
                        attrs: {
                          to: {
                            name: "purchases.grouped.item.view",
                            params: { group: "fl44", id: _vm.contract.id },
                            hash: "#atmo-disputes",
                          },
                          exact: "",
                          target: "_blank",
                        },
                      },
                      [_vm._v(" Ответить на протокол разногласий ")]
                    )
                  : _vm._e(),
                _c("cabinet-fl44-notice-card-copy-button", {
                  attrs: { purchase: _vm.contract },
                }),
                _vm.contract.actions
                  .customer_need_answer_supplementary_agreement_dispute
                  ? _c(
                      "b-button",
                      {
                        staticClass:
                          "btn btn-card-action btn-card-action-danger my-1",
                        attrs: {
                          exact: "",
                          target: "_blank",
                          to: {
                            name: "purchases.grouped.item.view",
                            params: { group: "fl44", id: _vm.contract.id },
                            hash: "#atmo-disputes-resolution",
                          },
                        },
                      },
                      [_vm._v("Ответить на протокол разногласий ")]
                    )
                  : _vm._e(),
                _vm.contract.actions
                  .customer_need_sign_supplementary_agreement ||
                _vm.contract.actions.provider_need_sign_supplementary_agreement
                  ? _c(
                      "b-button",
                      {
                        staticClass:
                          "btn btn-card-action btn-card-action-danger my-1",
                        attrs: {
                          exact: "",
                          target: "_blank",
                          to: {
                            name: "purchases.grouped.item.view",
                            params: { group: "fl44", id: _vm.contract.id },
                            hash: "#atmo-contract-annexes",
                          },
                        },
                      },
                      [_vm._v("Подписать дополнительное соглашение ")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }